import { Component } from '@angular/core';
import { PatientsService } from '../../../../core/services/patient/patients.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboar-main',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './dashboar-main.component.html',
  styleUrl: './dashboar-main.component.scss',
})
export class DashboarMainComponent {
  totalPatientCount: number = 0;
  totalECGCount: number = 0;
  totalConsultationCount: number = 0;

  constructor(
    private patientsService: PatientsService,
    private translate: TranslateService
  ) {
    const userLang = 'tr';
    this.translate.use(userLang);
  }

  ngOnInit(): void {
    this.getDashboardInformations();
  }

  getDashboardInformations() {
    this.patientsService.dashboardCountInformations().subscribe({
      next: (res) => {
        this.totalPatientCount = res.totalPatientCount;
        this.totalECGCount = res.totalECGCount;
        this.totalConsultationCount = res.totalConsultationCount;
      },
      error: () => {},
    });
  }
}
